<div class="main-page">
  <div class="text-9xl font-bold flex items-center">COMEON</div>
</div>
